export const admin = [
  {
    path: "/espace-admin",
    name: "espace.admin",
    meta: { auth: true },
    component: () => import("../layouts/AdminLayout.vue"),

    children: [
      {
        path: "/espace-admin-dashboard",
        name: "espace.admin.home",
        // redirect: { name: 'espace.de.moncv' }
        component: () => import("../components/admin/Dashboard.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-film",
        name: "espace.admin.film",
        component: () => import("../components/admin/Film.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-session-film",
        name: "espace.admin.session",
        component: () => import("../components/admin/Programme.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-salle",
        name: "espace.admin.salle",
        component: () => import("../components/admin/Salle.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-tarif",
        name: "espace.admin.tarif",
        component: () => import("../components/admin/Tarif.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-pays",
        name: "espace.admin.pays",
        component: () => import("../components/admin/Pays.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-horraire",
        name: "espace.admin.horraire",
        component: () => import("../components/admin/Horaire.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-reseau",
        name: "espace.admin.reseau",
        component: () => import("../components/admin/Reseaux.vue"),
        meta: {
          auth: true,
        },
      },

      {
        path: "/espace-admin-agregateur",
        name: "espace.admin.agregateur",
        component: () => import("../components/admin/Agregateur.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-type-confiserie",
        name: "espace.admin.type.confiserie",
        component: () => import("../components/admin/Confiserie.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-vente-periode",
        name: "espace.admin.vente.periode",
        component: () => import("../components/admin/Facture.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-vente-projection",
        name: "espace.admin.vente.projection",
        component: () => import("../components/admin/Dashboard.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-annulation",
        name: "espace.admin.annulation",
        component: () => import("../components/admin/Dashboard.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-confiserie-situation-periode",
        name: "espace.admin.confiserie.situation.periode",
        component: () => import("../components/admin/Dashboard.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-confiserie-situation-projection",
        name: "espace.admin.confiserie.situation.projection",
        component: () => import("../components/admin/Dashboard.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-utilisateur",
        name: "espace.admin.utilisateur",
        component: () => import("../components/admin/Utilisateur.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-ticket",
        name: "espace.admin.ticket",
        component: () => import("../components/admin/Ticket.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-note-avis",
        name: "espace.admin.note.avis",
        component: () => import("../components/admin/NoteAvis.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-attribut",
        name: "espace.admin.import.veezy",
        component: () => import("../components/admin/Attribut.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-attribut-exclure",
        name: "espace.admin.import.attribut.exclure",
        component: () => import("../components/admin/AttributExclure.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-attribut-import",
        name: "espace.admin.import.attribut.import",
        component: () => import("../components/admin/import/ImportVeezi.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-paiement",
        name: "espace.admin.paiement",
        component: () => import("../components/admin/Paiment.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-permission",
        name: "espace.admin.permission",
        component: () => import("../components/admin/Permission.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-screen",
        name: "espace.admin.screen",
        component: () => import("../components/admin/Ecran.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-logs",
        name: "espace.admin.logs",
        component: () => import("../components/admin/Journalisation.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-prix",
        name: "espace.admin.prix",
        component: () => import("../components/admin/Prix.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-roles",
        name: "espace.admin.roles",
        component: () => import("../components/admin/Role.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-remboursement",
        name: "espace.admin.remboursement",
        component: () => import("../components/admin/Remboursement.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-flux",
        name: "espace.admin.flux",
        component: () => import("../components/admin/Flux.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/profil",
        name: "profil",
        component: () => import("../components/admin/Profil.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-banniere",
        name: "espace.admin.banniere",
        component: () => import("../components/admin/Banniere.vue"),
        meta: {
          auth: true,
        },
      },
      {
        path: "/espace-admin-token",
        name: "espace.admin.token",
        component: () => import("../components/admin/Token.vue"),
        meta: {
          auth: true,
        },
      },
    ],
  },
];
